import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { ChangePasswordModal } from '../ChangePasswordModal';
import { useAuth } from '../../hooks/auth';
import { useUserDocument } from '../../services/contexts/UserDocumentContext';
import defaultTheme from '../../styles/themes/default';
import { CnpjMask } from '../../utils/CnpjMask';
import { CpfMask } from '../../utils/CpfMask';
import { ActionsContainer, Button, Container, SelectContainer } from './styles';

const companySelectStyle = {
  control: (base: any) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    minHeight: 'unset',
    height: 26,
    backgroundColor: 'transparent',
    cursor: 'pointer',
  }),
  valueContainer: (base: any) => ({ ...base, padding: '0 8px' }),
  indicatorsContainer: (base: any) => ({ ...base, height: 26 }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base: any) => ({ ...base, padding: 4 }),
  singleValue: (base: any) => ({
    ...base,
    fontSize: 12,
    color: defaultTheme.colors.gray[500],
  }),
  placeholder: (base: any) => ({ ...base, fontSize: 12 }),
  menu: (base: any) => ({ ...base, fontSize: 12, minWidth: 200 }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (base: any, { isFocused, isSelected }: any) => ({
    ...base,
    fontSize: 12,
    backgroundColor: isSelected
      ? defaultTheme.colors.orange.primary
      : isFocused
        ? defaultTheme.colors.gray[100]
        : '#fff',
    color: isSelected ? '#fff' : defaultTheme.colors.gray[600],
    cursor: 'pointer',
  }),
};

export const Header = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const { documentSelected, setDocumentSelected, documents } =
    useUserDocument();
  const [changePasswordModal, setChangePasswordModal] = useState(false);

  const options = documents?.map((doc) => ({
    value: doc.value,
    label: doc?.value?.length === 14 ? CnpjMask(doc.value) : CpfMask(doc.value),
  }));

  const selected =
    options?.find((option) => option.value === documentSelected) ?? null;

  return (
    <Container>
      <div className="welcomeContainer">
        <span> Bem-vindo(a), {user.name}</span>
        {documents && documents.length > 0 && (
          <div>
            <span>Selecione a empresa:</span>
            <SelectContainer>
              <Select
                options={options}
                value={selected}
                onChange={(option) =>
                  setDocumentSelected(option ? option.value : '')
                }
                isSearchable={false}
                styles={companySelectStyle}
                menuPortalTarget={
                  typeof document !== 'undefined' ? document.body : undefined
                }
              />
            </SelectContainer>
          </div>
        )}
      </div>
      <ActionsContainer>
        <Button type="button" onClick={() => setChangePasswordModal(true)}>
          Mudar senha
        </Button>
        <Button
          type="button"
          onClick={() => {
            signOut();
            navigate('/');
          }}
        >
          Sair
        </Button>
      </ActionsContainer>
      {changePasswordModal && (
        <ChangePasswordModal onClose={() => setChangePasswordModal(false)} />
      )}
    </Container>
  );
};
